import React, { ReactNode, CSSProperties } from 'react';
import { OutlineChevronDownIcon, OutlineChevronUpIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

interface IDropdownMenuProps {
  children: ReactNode;
  isOpen: boolean;
  toggleDropdown: () => void;
}

export const DropdownMenu = ({ children, isOpen, toggleDropdown }: IDropdownMenuProps) => {
  const dropdownContentStyle: CSSProperties = {
    position: 'absolute',
    width: '240px',
    top: '62px',
    backgroundColor: colors.shades[0],
    right: '-30px',
    boxShadow: '0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
    opacity: isOpen ? 1 : 0,
    visibility: isOpen ? 'visible' : 'hidden',
    transition: 'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out',
  };

  const toggleContentStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    color: isOpen ? colors.success[500] : colors.shades[0],
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        onClick={toggleDropdown}
        style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
      >
        <div style={toggleContentStyle}>
          <p
            style={{
              marginRight: '10px',
              fontSize: 18,
              fontWeight: 'bold',
              fontFamily: 'Nunito',
            }}
          >
            Explore GoTu
          </p>
          {isOpen
            ? <OutlineChevronUpIcon size={24} color={colors.secondary[500]} />
            : <OutlineChevronDownIcon size={24} color={colors.secondary[500]} />
          }
        </div>
      </div>
      <div id="dropdown-content" style={dropdownContentStyle}>
        {children}
      </div>
    </div>
  );
};
